export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_09.95debaf7.jpg";